import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import {
  NumberInput,
  SelectInput, minValue, required,
} from 'react-admin';

import { timePeriodChoices } from '../../../constants/timePeriods';
import Label from '../../../customFields/Label';
import TransactionTypeConfiguration from './TransactionTypeConfiguration';
import transactionMonitoringModes, { transactionMonitoringModesChoices } from '../../../constants/transactionMonitoringMode';
import anomalyDeviationDirections, { anomalyDeviationDirectionChoices } from '../../../constants/anomalyDeviationDirections';

const SimpleAnomalyDetectionWithoutWindow = () => (
  <Grid size={12}>
    <Grid container spacing={1}>
      <Grid size={12}>
        <TransactionTypeConfiguration />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput
          source="ruleParameters.transactionMonitoringMode"
          choices={transactionMonitoringModesChoices}
          fullWidth
          label="Transaction monitoring mode"
          validate={[required()]}
          defaultValue={transactionMonitoringModes.ALL_RELATED}
        />
      </Grid>
      <Grid size={12}>
        <Label
          variant="label"
          title="The deviation percentage and direction which this rule should detect."
          info={(
            <Box>
              <Typography>
                <Box component="span" fontWeight="bold">
                  Lower.
                </Box>
                {' '}
                Detect if the deviation is lower than the historical average.
              </Typography>
              <Typography>
                <Box component="span" fontWeight="bold">
                  Higher.
                </Box>
                {' '}
                Detect if the deviation is higher than the historical average.
              </Typography>
              <Typography>
                <Box component="span" fontWeight="bold">
                  Both.
                </Box>
                {' '}
                Detect both lower and higher deviation from the historical average.
              </Typography>
            </Box>
          )}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberInput source="ruleParameters.threshold" fullWidth label="Deviation (%)" />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput choices={anomalyDeviationDirectionChoices} defaultValue={anomalyDeviationDirections.BOTH} source="ruleParameters.deviationDirection" label="Deviation Direction" fullWidth />
      </Grid>
      <Grid size={12}>
        <NumberInput source="ruleParameters.minimumNumberOfObservations" fullWidth />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="Minimum usage time"
          info="The period will determine if a entity have been in the system long enough to be used."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberInput
          source="ruleParameters.minimumUsageTime.amount"
          fullWidth
          label="Length"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput
          source="ruleParameters.minimumUsageTime.unit"
          choices={timePeriodChoices}
          fullWidth
          label="Period"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid size={12}>
        <Label
          variant="label"
          title="Period to consider"
          info="The period that will be used to determine the start of the history to include."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberInput
          source="ruleParameters.periodToConsider.amount"
          fullWidth
          label="Length"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput
          source="ruleParameters.periodToConsider.unit"
          choices={timePeriodChoices}
          fullWidth
          label="Period"
          validate={[required(), minValue(1)]}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default SimpleAnomalyDetectionWithoutWindow;
